document.addEventListener("sections:loaded", () => {
  const trigger = document.querySelector(".product-add-to-cart");
  const bar = document.querySelector(".sticky-cart");
  const scrollButton = bar ? bar.querySelector(".sticky-cart-button") : null;

  if (!trigger || !bar) {
    return;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle("is-visible", scrolledPast);
    },
    { threshold: 0 },
  );

  observer.observe(trigger);

  if (scrollButton) {
    scrollButton.addEventListener("click", () => {
      const triggerTop = trigger.getBoundingClientRect().top + window.scrollY;
      const targetTop = triggerTop - window.innerHeight * 0.75;
      window.scrollTo({ top: targetTop, behavior: "smooth" });
      trigger.focus({ preventScroll: true });
    });
  }
});
